var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_",
    "data-name": "?",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    fill: "#1f3a93",
    stroke: "#1f3a93",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(7 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-question-mark",
    "data-name": "Icon open-question-mark",
    d: "M5.038,0A5.271,5.271,0,0,0,1.2,1.346,4.451,4.451,0,0,0,0,3.957l2.04.265a2.472,2.472,0,0,1,.632-1.407A3.029,3.029,0,0,1,5.038,2.04a3.6,3.6,0,0,1,2.489.694A1.705,1.705,0,0,1,8.1,4.08c0,1.693-.694,2.162-1.713,3.06a5.814,5.814,0,0,0-2.366,4.59v.51h2.04v-.51c0-1.693.632-2.162,1.652-3.06a5.849,5.849,0,0,0,2.427-4.59A3.919,3.919,0,0,0,8.934,1.2,5.638,5.638,0,0,0,5.038,0ZM4.018,14.279v2.04h2.04v-2.04Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.13821488143a7d3c2218e619a3100a0d.svg";
export { ForwardRef as ReactComponent };